import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Uptime} from './uptime';
import styles from './integration_hero.module.less';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';
import {t_integration_item} from '../../../../toolip/pub/ui/integrations_hero/integrations_hero';
import {Integration_buttons} from '../../../../toolip/pub/ui/integration_buttons/integration_buttons';
import {Integration_buttons_icons} from '../../../../toolip/pub/ui/integration_buttons_icons/integration_buttons_icons';
import {i_integrations_heading_props} from '../../../../toolip/pub/ui/integrations_hero/integrations_heading';

interface i_integrations_items extends i_integrations_heading_props {
    items: t_integration_item[];
}

export const Integration_hero = (props: i_integrations_items)=>{
    const items = props?.items || [];
    const {theme} = useContext(Settings_context);
    const integration_button_groups = React.useMemo(()=>{
        const categories = Array.from(new Set(items.map(item=>item.category)));
        return categories.map(category=>({
            value: category,
            label: category.charAt(0).toUpperCase() + category.slice(1).replace(/_/g, ' ')
        }));
    }, [items]);
    const grouped_items = React.useMemo(()=>{
      return items.reduce((acc, item)=>{
          if (!acc[item.category])
              acc[item.category] = [];
          acc[item.category].push(item);
          return acc;
      }, {});
    }, [items]);
    const initial_active_category = integration_button_groups[0]?.value ?? '';
    const [active_category, set_active_category] =
        useState<string>(initial_active_category);

    const integration_buttons_icons_items = React.useMemo(()=>{
        if (!active_category || !grouped_items[active_category])
            return [];
        return grouped_items[active_category].map(item=>({
            id: item.id,
            img: item.icon,
            name: item.name,
            link: item.link,
            category: item.category,
        }));
    }, [active_category, grouped_items]);
    useEffect(()=>{
        if (initial_active_category && !active_category)
            set_active_category(initial_active_category);
    }, [initial_active_category, active_category]);

  return <div>
    <div className={styles.integration_hero_wrapper}>
      <div className={cn(theme.container, styles.container)}>
        <div className={cn(styles.integration_hero_top)}>
          <Uptime />
        </div>
        <div className={styles.integration_hero_text_wrapper}>
          <Dynamic_heading className={cn(styles.integration_hero_title)}
            tag={props.title_tag} dangerouslySetInnerHTML={
              {__html: props.title ||
                'Seamlessly integrate with Oculus to power up your proxies'}}/>
        </div>
        <div className={styles.groups_block}>
          <Integration_buttons
            groups={integration_button_groups}
            active_category={active_category}
            on_category_change={set_active_category}
          />
          <Integration_buttons_icons
            items={integration_buttons_icons_items}
          />
        </div>
      </div>
    </div>
  </div>;
};
